export var dataKey = 'text';


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-form/es/util/eventConsts.js
// module id = 428
// module chunks = 0